import React from 'react';
import { orderBy, } from 'lodash';
import { format as formatDate, } from 'date-fns';

import { functions } from '../firebase';
import ModalButton from './ModalButton';
import DeleteButton from './DeleteButton';
import ProgressButton from './ProgressButton';
import useCompany from './hooks/useCompany';
import useCollectionSubscription from './hooks/useCollectionSubscription';

const getImportFileSinedUrl = functions.httpsCallable('getImportFileSinedUrl');

export default function ImportHistoryButton ({ importKey, beforeDeleteImport = _ => true, deleteImportConfirmMessage, deleteImportDisabled = _ => false, }) {
  return (
    <span onClick={e => e.stopPropagation()}>
      <ModalButton title="インポート履歴" color="lightgray" size="sm" className="ml-2 px-2 py-0" content={_ => <HistoryModalContent importKey={importKey} beforeDeleteImport={beforeDeleteImport} deleteImportConfirmMessage={deleteImportConfirmMessage} deleteImportDisabled={deleteImportDisabled} />}>
        <span className="fas fa-history" />
      </ModalButton>
    </span>
  );
}

function HistoryModalContent (props) {
  const { importKey, beforeDeleteImport, deleteImportConfirmMessage, deleteImportDisabled, } = props;
  const company = useCompany();
  const imports = useCollectionSubscription(company.ref.collection('imports').where('key', '==', importKey), [company, importKey]);
  return (
    <table className="table table-bordered">
      <tbody>
        {
          orderBy(imports, _ => _.createdAt.toDate(), 'desc').map((_import) => {
            const { id, ref, fileName, createdAt, } = _import;
            const onClickDownload = async () => {
              const { data: { url } } = await getImportFileSinedUrl({ companyId: company.id, importId: id });
              window.open(url);
            };

            return (
              <tr key={id}>
                <td>
                  {formatDate(createdAt.toDate(), 'yyyy/MM/dd HH:mm:ss')}
                </td>
                <td>
                  {fileName}
                </td>
                <td className="text-nowrap">
                  <ProgressButton icon={<span className="fas fa-download" />} process={onClickDownload} />
                  <DeleteButton className="ml-1" item={_import} itemRef={ref} beforeDelete={beforeDeleteImport} confirmMessage={deleteImportConfirmMessage} disabled={deleteImportDisabled(id)} />
                </td>
              </tr>
            );
          })
        }
      </tbody>
    </table>
  );
}
